/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { QuizDefinitionDto } from '../models';
// @ts-ignore
import type { QuizIdentifierDto } from '../models';
/**
 * RestQuizApi - axios parameter creator
 * @export
 */
export const RestQuizApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get quiz definition
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuizDefinition: async (quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('getQuizDefinition', 'quizId', quizId)
            const localVarPath = `/api/quizzes/{quizId}`
                .replace(`{${"quizId"}}`, encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get quiz identifiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuizIdentifiers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quizzes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestQuizApi - functional programming interface
 * @export
 */
export const RestQuizApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestQuizApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get quiz definition
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuizDefinition(quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizDefinitionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuizDefinition(quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestQuizApi.getQuizDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get quiz identifiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuizIdentifiers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QuizIdentifierDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuizIdentifiers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestQuizApi.getQuizIdentifiers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestQuizApi - factory interface
 * @export
 */
export const RestQuizApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestQuizApiFp(configuration)
    return {
        /**
         * 
         * @summary get quiz definition
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuizDefinition(quizId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuizDefinitionDto> {
            return localVarFp.getQuizDefinition(quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get quiz identifiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuizIdentifiers(options?: RawAxiosRequestConfig): AxiosPromise<Array<QuizIdentifierDto>> {
            return localVarFp.getQuizIdentifiers(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestQuizApi - interface
 * @export
 * @interface RestQuizApi
 */
export interface RestQuizApiInterface {
    /**
     * 
     * @summary get quiz definition
     * @param {string} quizId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestQuizApiInterface
     */
    getQuizDefinition(quizId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuizDefinitionDto>;

    /**
     * 
     * @summary get quiz identifiers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestQuizApiInterface
     */
    getQuizIdentifiers(options?: RawAxiosRequestConfig): AxiosPromise<Array<QuizIdentifierDto>>;

}

/**
 * RestQuizApi - object-oriented interface
 * @export
 * @class RestQuizApi
 * @extends {BaseAPI}
 */
export class RestQuizApi extends BaseAPI implements RestQuizApiInterface {
    /**
     * 
     * @summary get quiz definition
     * @param {string} quizId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestQuizApi
     */
    public getQuizDefinition(quizId: string, options?: RawAxiosRequestConfig) {
        return RestQuizApiFp(this.configuration).getQuizDefinition(quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get quiz identifiers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestQuizApi
     */
    public getQuizIdentifiers(options?: RawAxiosRequestConfig) {
        return RestQuizApiFp(this.configuration).getQuizIdentifiers(options).then((request) => request(this.axios, this.basePath));
    }
}

